<template>
  <div>
    <!-- Text that displays '2D LIDAR' -->
    <div class="collapsed-text align-lidarText">2D LIDAR</div>
    <!-- Toggleable Lidar Panel Button -->
    <div id="lidarPanelToggle" @click="toggleLidar()">
      <fa
        :icon="['fas', faIcon]"
        size="3x"
        :class="`collapsed-symbol ${faIconClass}`"
      />
      <p
        v-if="faIcon == 'exclamation-triangle'"
        class="no-drag lidar-warning clickable"
      >
        ZOOM IN
      </p>
    </div>
  </div>
</template>

<style scoped>
.lidar-warning {
  position: relative;
  font-size: 11px;
  color: #b5b5b5;
  top: 90px;
  left: 31px;
}
</style>

<script>
export default {
  name: 'MMP_CollapsedLidarToggle',
  props: ['lidarMinZoomAchieved', 'showLidarPanel'],
  data() {
    return {
      faIcon: 'exclamation-triangle',
      faIconClass: 'collapsed-yellow'
    }
  },
  methods: {
    setLidarIcon() {
      /* If user is zoomed in far enough to use lidar, use
      layer-group icon instead of exclamation-triangle icon */
      this.faIcon = this.lidarMinZoomAchieved ? 'layer-group' : 'exclamation-triangle'
      this.setLidarIconClass()
    },
    setLidarIconClass() {
      if (this.faIcon == 'exclamation-triangle') {
        this.faIconClass = 'collapsed-yellow'
      } else {
        if (this.showLidarPanel) {
          this.faIconClass = 'collapsed-blue'
        } else {
          this.faIconClass = 'collapsed-gray'
        }
      }
    },
    toggleLidar() {
      /* Only enables/disables Lidar if the
      user is at an appropriate zoom level */
      if (this.lidarMinZoomAchieved) {
        this.$emit('lidarToggleChange')
      }
    },
    keyDownHandler(event) {
      if (['input', 'b-form-textarea', 'b-form-input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
        return;
      }
      if (event.key === 'L' || event.key === 'l') {
        this.toggleLidar()
      }
    }
  },
  mounted() {
    this.setLidarIcon()

    window.addEventListener('keydown', this.keyDownHandler)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  watch: {
    lidarMinZoomAchieved: function (newValue, oldValue) {
      this.setLidarIcon()
    },
    showLidarPanel: function (newValue, oldValue) {
      this.setLidarIcon()
    }
  }
}
</script>
